import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4af817dd = () => interopDefault(import('../pages/admin.vue' /* webpackChunkName: "pages/admin" */))
const _7bde27c2 = () => interopDefault(import('../pages/admin/gebruikers/index.vue' /* webpackChunkName: "pages/admin/gebruikers/index" */))
const _41c46910 = () => interopDefault(import('../pages/admin/opdrachtgevers/index.vue' /* webpackChunkName: "pages/admin/opdrachtgevers/index" */))
const _21ddf8d3 = () => interopDefault(import('../pages/admin/projecten/index.vue' /* webpackChunkName: "pages/admin/projecten/index" */))
const _279b1b3c = () => interopDefault(import('../pages/admin/gebruikers/create.vue' /* webpackChunkName: "pages/admin/gebruikers/create" */))
const _1e7d03ae = () => interopDefault(import('../pages/admin/opdrachtgevers/create.vue' /* webpackChunkName: "pages/admin/opdrachtgevers/create" */))
const _41956c4b = () => interopDefault(import('../pages/admin/projecten/create.vue' /* webpackChunkName: "pages/admin/projecten/create" */))
const _435554d0 = () => interopDefault(import('../pages/admin/projecten/update.vue' /* webpackChunkName: "pages/admin/projecten/update" */))
const _a6119aac = () => interopDefault(import('../pages/admin/gebruikers/_id.vue' /* webpackChunkName: "pages/admin/gebruikers/_id" */))
const _6b0d2110 = () => interopDefault(import('../pages/admin/opdrachtgevers/_id.vue' /* webpackChunkName: "pages/admin/opdrachtgevers/_id" */))
const _1498723e = () => interopDefault(import('../pages/admin/projecten/_id/index.vue' /* webpackChunkName: "pages/admin/projecten/_id/index" */))
const _3a1a7250 = () => interopDefault(import('../pages/admin/projecten/_id/update/index.vue' /* webpackChunkName: "pages/admin/projecten/_id/update/index" */))
const _50d5cf01 = () => interopDefault(import('../pages/admin/projecten/_id/update/_updateid.vue' /* webpackChunkName: "pages/admin/projecten/_id/update/_updateid" */))
const _2ebb2416 = () => interopDefault(import('../pages/inloggen/index.vue' /* webpackChunkName: "pages/inloggen/index" */))
const _42f735a4 = () => interopDefault(import('../pages/instellingen.vue' /* webpackChunkName: "pages/instellingen" */))
const _fc8fafda = () => interopDefault(import('../pages/projecten/index.vue' /* webpackChunkName: "pages/projecten/index" */))
const _dcb8919e = () => interopDefault(import('../pages/inloggen/callback.vue' /* webpackChunkName: "pages/inloggen/callback" */))
const _91a50380 = () => interopDefault(import('../pages/inloggen/over.vue' /* webpackChunkName: "pages/inloggen/over" */))
const _35304ea9 = () => interopDefault(import('../pages/inloggen/wachtwoord-vergeten.vue' /* webpackChunkName: "pages/inloggen/wachtwoord-vergeten" */))
const _0747133b = () => interopDefault(import('../pages/projecten/_id.vue' /* webpackChunkName: "pages/projecten/_id" */))
const _8daad3d0 = () => interopDefault(import('../pages/wachtwoord-instellen/_token.vue' /* webpackChunkName: "pages/wachtwoord-instellen/_token" */))
const _1988c3e0 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/admin",
    component: _4af817dd,
    pathToRegexpOptions: {"strict":true},
    name: "admin",
    children: [{
      path: "gebruikers",
      component: _7bde27c2,
      pathToRegexpOptions: {"strict":true},
      name: "admin-gebruikers"
    }, {
      path: "opdrachtgevers",
      component: _41c46910,
      pathToRegexpOptions: {"strict":true},
      name: "admin-opdrachtgevers"
    }, {
      path: "projecten",
      component: _21ddf8d3,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten"
    }, {
      path: "gebruikers/create",
      component: _279b1b3c,
      pathToRegexpOptions: {"strict":true},
      name: "admin-gebruikers-create"
    }, {
      path: "opdrachtgevers/create",
      component: _1e7d03ae,
      pathToRegexpOptions: {"strict":true},
      name: "admin-opdrachtgevers-create"
    }, {
      path: "projecten/create",
      component: _41956c4b,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten-create"
    }, {
      path: "projecten/update",
      component: _435554d0,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten-update"
    }, {
      path: "gebruikers/:id",
      component: _a6119aac,
      pathToRegexpOptions: {"strict":true},
      name: "admin-gebruikers-id"
    }, {
      path: "opdrachtgevers/:id",
      component: _6b0d2110,
      pathToRegexpOptions: {"strict":true},
      name: "admin-opdrachtgevers-id"
    }, {
      path: "projecten/:id",
      component: _1498723e,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten-id"
    }, {
      path: "projecten/:id/update",
      component: _3a1a7250,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten-id-update"
    }, {
      path: "projecten/:id/update/:updateid",
      component: _50d5cf01,
      pathToRegexpOptions: {"strict":true},
      name: "admin-projecten-id-update-updateid"
    }]
  }, {
    path: "/inloggen",
    component: _2ebb2416,
    pathToRegexpOptions: {"strict":true},
    name: "inloggen"
  }, {
    path: "/instellingen",
    component: _42f735a4,
    pathToRegexpOptions: {"strict":true},
    name: "instellingen"
  }, {
    path: "/projecten",
    component: _fc8fafda,
    pathToRegexpOptions: {"strict":true},
    name: "projecten"
  }, {
    path: "/inloggen/callback",
    component: _dcb8919e,
    pathToRegexpOptions: {"strict":true},
    name: "inloggen-callback"
  }, {
    path: "/inloggen/over",
    component: _91a50380,
    pathToRegexpOptions: {"strict":true},
    name: "inloggen-over"
  }, {
    path: "/inloggen/wachtwoord-vergeten",
    component: _35304ea9,
    pathToRegexpOptions: {"strict":true},
    name: "inloggen-wachtwoord-vergeten"
  }, {
    path: "/projecten/:id",
    component: _0747133b,
    pathToRegexpOptions: {"strict":true},
    name: "projecten-id"
  }, {
    path: "/wachtwoord-instellen/:token?",
    component: _8daad3d0,
    pathToRegexpOptions: {"strict":true},
    name: "wachtwoord-instellen-token"
  }, {
    path: "/",
    component: _1988c3e0,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
